import { gql } from 'graphql-request'

export namespace PotentialBookingsMutations {
  export function createPotentialBooking() {
    return gql`
      mutation createPotentialBooking($potentialBooking: PotentialBookingInsertMutation) {
        createPotentialBooking(potentialBooking: $potentialBooking) {
          id
        }
      }
    `
  }

  export function updatePotentialBooking() {
    return gql`
      mutation updatePotentialBooking($potentialBooking: PotentialBookingUpdateMutation) {
        updatePotentialBooking(potentialBooking: $potentialBooking) {
          id
        }
      }
    `
  }

  export function updateAgentForPotentialBookings() {
    return gql`
      mutation updateAgentForPotentialBookings($potentialBookingIds: [Int!], $agentId: Int!) {
        updateAgentForPotentialBookings(potentialBookingIds: $potentialBookingIds, agentId: $agentId)
      }
    `
  }

  export function updateStatusForPotentialBookings() {
    return gql`
      mutation updateStatusForPotentialBookings($potentialBookingIds: [Int!], $potentialBookingStatusId: Int!) {
        updateStatusForPotentialBookings(
          potentialBookingIds: $potentialBookingIds
          potentialBookingStatusId: $potentialBookingStatusId
        )
      }
    `
  }
}
